import axios from "axios";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useApp } from "../../ctx/App";
import ErrorMessage from "../atoms/ErrorMessage";
import Select from "../atoms/Select";
import InputWithLabel from "../molecules/InputWithLabel";
import Label from "../molecules/Label";

import DayPickerInput from "react-day-picker/DayPickerInput";
import { DateUtils } from "react-day-picker";

import {
  capitalize,
  isEmpty,
  isEqual,
  pick,
  flattenDeep,
  uniqueId,
  upperCase,
} from "lodash";
import toast from "react-hot-toast";
import dateFnsFormat from "date-fns/format";
import dateFnsParse from "date-fns/parse";
import { getDates } from "../../utils";

function parseDate(str, format, locale) {
  const parsed = dateFnsParse(str, format, new Date(), { locale });
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale });
}

const daysOfWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

function DatePicker({ control, name }) {
  const {
    state: {
      clientBookingDetails: { testSelection },
    },
  } = useApp();

  const FORMAT = "PPP";

  // modifiers
  const bookingDays = JSON.parse(testSelection?.product_booking_days);
  const closedDays = bookingDays
    // ?.filter((v) => false)
    ?.filter((v) => v?.isClosed)
    ?.map((v, i) => {
      return daysOfWeek[v?.day];
    });

  // console.log(closedDays);

  const bookingDates = JSON.parse(testSelection?.product_booking_dates)?.length
    ? JSON.parse(testSelection?.product_booking_dates)
    : [];

  const allDatesArray = flattenDeep(
    bookingDates?.map((v) => getDates(new Date(v?.from), new Date(v?.to)))
  );
  // console.log(bookingDates);
  // console.log(allDatesArray);

  const disabledDays = allDatesArray;

  const isDayDisabled = (day) =>
    !disabledDays.some((disabledDay) => DateUtils.isSameDay(day, disabledDay));

  // console.log(isDayDisabled);

  return (
    <div>
      <Controller
        control={control}
        name={name}
        rules={{
          validate: (value) => Boolean(value) || "Booking date must be entered",
        }}
        render={({
          field: { onChange, onBlur, value, ref },
          fieldState: { invalid, isTouched, isDirty, error },
        }) => {
          return (
            <>
              <DayPickerInput
                ref={ref}
                value={value}
                onDayChange={(day) => {
                  // console.log(dateFnsFormat(day, "PPPP"));
                  onChange(day);
                  // onChange(dateFnsFormat(day, "PPPP"));
                }}
                formatDate={formatDate}
                format={FORMAT}
                parseDate={parseDate}
                placeholder={`Select a date`}
                dayPickerProps={{
                  disabledDays: [
                    bookingDates?.length && isDayDisabled,
                    {
                      before: new Date(),
                    },

                    {
                      daysOfWeek: closedDays,
                    },
                  ],
                }}
                // placeholder={`${dateFnsFormat(new Date(), FORMAT)}`}
              />

              {/* <p className="text-xs text-red-500">{error?.message}</p> */}
            </>
          );
        }}
      />
    </div>
  );
}

const Book = () => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const bookingDate = watch("bookingDate");
  const watchBookingPhoneNumber = watch("phone", "");

  const {
    state: {
      provider: {
        providerDetails,
        providerOutletDetails,
        providerMerchantDetails,
      },
      clientBookingDetails: { testSelection },
    },
    actions: { setComponentToRender, setClientBookingDetails },
  } = useApp();

  const [timeSlots, setTimeSlots] = React.useState([
    {
      name: `Select a date to proceed`,
      value: "",
    },
  ]);

  const [regions] = React.useState([
    {
      name: `Select a region`,
      value: "",
    },
    {
      name: `Ahafo Region`,
      value: "Ahafo Region",
    },
    {
      name: `Ashanti Region`,
      value: "Ashanti Region",
    },
    {
      name: `Bono East Region`,
      value: "Bono East Region",
    },
    {
      name: `Bono Region`,
      value: "Bono Region",
    },
    {
      name: `Central Region`,
      value: "Central Region",
    },
    {
      name: `Eastern Region`,
      value: "Eastern Region",
    },
    {
      name: `Greater Accra Region`,
      value: "Greater Accra Region",
    },
    {
      name: `North East Region`,
      value: "North East Region",
    },
    {
      name: `Northern Region`,
      value: "Northern Region",
    },
    {
      name: `Oti Region`,
      value: "Oti Region",
    },
    {
      name: `Savannah Region`,
      value: "Savannah Region",
    },
    {
      name: `Upper East Region`,
      value: "Upper East Region",
    },
    {
      name: `Upper West Region`,
      value: "Upper West Region",
    },
    {
      name: `Volta Region`,
      value: "Volta Region",
    },
    {
      name: `Western North Region`,
      value: "Western North Region",
    },

    {
      name: `Western Region`,
      value: "Western Region",
    },
  ]);

  const [loading, setLoading] = React.useState(false);

  // console.log({ bookingDate });
  // console.log(testSelection?.product_properties_variants);

  React.useEffect(() => {
    if (bookingDate) {
      setTimeSlots([
        {
          name: `Select a date to proceed`,
          value: "",
        },
      ]);

      (async () => {
        const pastOrdersRes = await axios.post("/api/past-orders", {
          merchant: providerDetails?.store_merchant,
          date: bookingDate,
        });
        const pastOrdersResData = pastOrdersRes?.data ?? {};
        // console.log(pastOrdersResData);

        if (Number(pastOrdersResData?.status) === 0) {
          const pastOrdersSize = pastOrdersResData?.data?.length;
          // console.log(pastOrdersSize);

          if (!pastOrdersSize) {
            setTimeSlots(
              [
                {
                  name: `Select a time option`,
                  value: "",
                },
              ].concat(
                (testSelection?.product_properties_variants || []).map(
                  (property) => {
                    return {
                      disabled: false,
                      name: property?.variantOptionValue?.Time,
                      value: property?.variantOptionValue?.Time,
                    };
                  }
                )
              )
            );
          } else {
            setTimeSlots(
              [
                {
                  name: `Select a time option`,
                  value: "",
                },
              ].concat(
                (testSelection?.product_properties_variants || [])
                  // (testSelection?.product_properties || [])
                  .map((property) => {
                    const quantity =
                      Number(property?.variantOptionBookingSlot) === -99
                        ? 10000000000000
                        : Number(property?.variantOptionBookingSlot);
                    const pastOrders = pastOrdersResData?.data;

                    const sizeOfPastOrders = pastOrders.filter(
                      (order) =>
                        order?.order_slot === property?.variantOptionValue?.Time
                    )?.length;

                    const isFull = sizeOfPastOrders >= quantity;

                    // if (isFull) return null; // if is full, return null
                    return {
                      disabled: isFull,
                      name: property?.variantOptionValue?.Time,
                      value: property?.variantOptionValue?.Time,
                    };
                  })
                  .filter(Boolean) // if is full remove null from array
              )
            );
          }
        }
      })();
    }

    return () => {};
  }, [
    bookingDate,
    providerDetails?.store_merchant,
    testSelection?.product_properties_variants,
  ]);

  // console.log(testSelection);

  const cartItemsTotalPrice = (items, coupon = null) => {
    let total = items.reduce((price, product) => {
      return price + product?.totalPrice;
    }, 0);
    const discount = coupon ? total * coupon : 0;

    return Number(parseFloat(total - discount));
  };

  const getCartItemsPrice = (items) =>
    Number(parseFloat(cartItemsTotalPrice(items).toFixed(2)));

  const onRaiseOrder = async (values) => {
    try {
      setLoading(true);
      const bookingTime = values?.bookingTime;

      const foundProperty = testSelection?.product_properties?.find(
        (item) => item?.property_value === bookingTime
      );

      const foundVariant = testSelection?.product_properties_variants?.find(
        (item) => {
          const values = Object.keys(item?.variantOptionValue);
          const foundKey = values.find(
            (item) => upperCase(item) === upperCase(foundProperty?.property_id)
          );

          return (
            item?.variantOptionValue[foundKey] === foundProperty?.property_value
          );
        }
      );

      // console.log(foundVariant);

      if (!foundVariant) return;

      const allItems = [
        {
          ...testSelection,
          price: Number(testSelection?.product_price),
          uniqueid: uniqueId(testSelection?.product_id),
          quantity: 1,
          totalPrice: Number(
            parseFloat(Number(testSelection?.product_price) * 1).toFixed(2)
          ),
          variantSelected: { [foundProperty?.property_id]: foundProperty },
          variantSelelectedID: foundVariant?.variantOptionId,
          variantSelelectedPrice: Number(foundVariant?.variantOptionPrice),
        },
      ];
      // console.log({ allItems });
      const items = allItems.reduce((acc, curr, index) => {
        // console.log(curr?.variantSelected);
        const variants = Object.values(curr?.variantSelected).map((variant) => {
          return `${capitalize(variant?.property_value)}`;
        });
        // console.log({ variants });

        const properties = Object.entries(curr?.variantSelected).reduce(
          (acc, variant, index) => {
            return {
              ...acc,
              [variant[0]]: [variant[1]][0]?.property_value || "Normal",
            };
          },
          {}
        );

        const addVariants =
          variants.length > 0 ? ` (${variants.join(", ")})` : "";
        // console.log(properties);
        // console.log(addVariants);

        return {
          ...acc,
          [index]: {
            order_item_no: curr?.product_id,
            order_item_qty: curr?.quantity,
            order_item: `${curr?.product_name}${
              isEqual(properties, { Type: "Normal" }) ? "" : addVariants
            }`,
            order_item_amt: curr?.totalPrice,
            order_item_prop: isEqual(properties, { Type: "Normal" })
              ? {}
              : properties,
            order_item_prop_id: curr?.variantSelelectedID,
          },
        };
      }, {});

      // console.log(values);
      let concatValues = "";
      const pickValues = ["uniName", "bookingDate", "bookingTime"];

      if (providerMerchantDetails?.merchant_id !== "MER11618") {
        pickValues.unshift([
          "IDNumber",
          "region",
          "hall", // must always be last since it's optional
        ]);
      }

      // passing it manually for Vodafone
      for (let i in {
        ...pick(values, [...pickValues]),
      }) {
        concatValues += `${i}=${values[i]}&`;
      }

      const data = {
        order_notes: concatValues,
        // order_items: items,
        order_items: JSON.stringify(items),
        delivery_outlet: providerOutletDetails[0]?.outlet_id,
        delivery_type: "WALK-IN",
        delivery_notes: "",
        delivery_id: providerOutletDetails[0]?.outlet_id,
        delivery_location: "",
        delivery_gps: "",
        delivery_charge_type: "",
        delivery_charge_ref: "",
        name: values?.studentName || "",
        number: values?.phone || "",
        delivery_contact: "",
        delivery_email: values?.email || "",
        order_amount: getCartItemsPrice(allItems),
        order_discount: 0,
        order_discount_code: "",
        order_discount_type: "",
        delivery_charge: 0,
        service_charge: 0,
        total_amount: getCartItemsPrice(allItems),
        merchant: providerDetails?.store_merchant,
        source: "BOOKING",
        mod_by: "CUSTOMER",
        customer: "",
        order_date: values.bookingDate,
        order_type: "BOOKING",
      };

      console.log(`payload`, data);
      setClientBookingDetails({
        bookingPayload: {
          ...data,
          order_items: items,
        },
      });

      const { data: resData } = await axios.post("/api/raise-order", data);
      // console.log(resData);

      if (Number(resData?.status) !== 0) {
        toast.error(resData?.message);
      } else {
        setClientBookingDetails({
          bookingResponse: resData,
        });
        toast.success(resData["payment-message"]);
        setComponentToRender("payment");
      }
    } catch (error) {
      let errorResponse = "";
      if (error.response) {
        errorResponse = error.response.data;
      } else if (error.request) {
        errorResponse = error.request;
      } else {
        errorResponse = { error: error.message };
      }
      console.log(errorResponse);
    } finally {
      setLoading(false);
    }
  };

  const validate = (dateString) => {
    const day = new Date(dateString).getDay();
    if (day === 0) {
      return false;
    }
    return true;
  };

  const handleBookingDate = (e) => {
    const value = e.target.value;
    // console.log(value);

    if (!validate(value)) {
      toast.error("Sorry. We do not work on Sundays");
      return setValue("bookingDate", "");
    }

    setValue("bookingDate", value);
  };

  // const bookingDateInput = register("bookingDate", {
  //   required: "Booking Date is required",
  // });

  React.useEffect(() => {
    // console.log(watchBookingPhoneNumber);
    if (watchBookingPhoneNumber?.length === 10) {
      (async () => {
        setLoading(true);
        const response = await axios.post("/api/customer-details", {
          phone: watchBookingPhoneNumber,
        });
        const responsedata = await response?.data;
        // console.log(responsedata);

        if (Number(responsedata?.status) === 0) {
          // console.log("here");
          if (responsedata?.data?.customer_email) {
            setValue(`email`, responsedata?.data?.customer_email || "");
          }
          if (responsedata?.data?.customer_name) {
            setValue(`studentName`, responsedata?.data?.customer_name || "");
          }
        } else {
          // console.log("there");
          // setValue(`email`, "");
          // setValue(`fullName`, "");
        }

        setLoading(false);
      })();
    }

    return () => {};
  }, [setValue, watchBookingPhoneNumber]);

  // console.log(loading);

  return (
    <div className="flex flex-col justify-center items-center w-full max-w-7xl">
      <div className="w-full">
        <div className="flex items-center w-full bg-brandBlue text-white text-xl h-10 pl-2">
          <h1>Booking and Payments System</h1>
        </div>

        <div className="px-3 lg:px-32 py-5">
          <h1 className="text-xl text-brandBlue font-bold">
            2. Client Information
          </h1>

          <hr className="my-2 border-gray-200 mb-5" />

          <div className="px-2">
            <div className="">
              {providerMerchantDetails?.merchant_id !== "MER11618" && (
                <div className="w-full mb-3">
                  <InputWithLabel
                    labelText={`Name of University`}
                    labelClasses="!capitalize !text-lg"
                    inputClasses="!border !border-gray-500"
                    {...register("uniName", {
                      required: "University name is required",
                    })}
                    type="text"
                    placeholder="University of Ghana"
                  />
                  <ErrorMessage text={errors?.uniName?.message} />
                </div>
              )}

              <div className="lg:flex justify-between w-full mb-3">
                <div className="lg:w-[48%] mb-3 lg:mb-0">
                  <InputWithLabel
                    labelText={`Name ${
                      providerMerchantDetails?.merchant_id !== "MER11618"
                        ? "of Student"
                        : ""
                    }`}
                    labelClasses="!capitalize !text-lg"
                    inputClasses="!border !border-gray-500"
                    {...register("studentName", {
                      required: "Student name is required",
                    })}
                    type="text"
                    placeholder="John Doe"
                  />
                  <ErrorMessage text={errors?.studentName?.message} />
                </div>

                {providerMerchantDetails?.merchant_id !== "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <InputWithLabel
                      labelText={`${
                        providerMerchantDetails?.merchant_id !== "MER11618"
                          ? "Student"
                          : ""
                      } ID Number`}
                      labelClasses="!capitalize !text-lg"
                      inputClasses="!border !border-gray-500"
                      {...register("IDNumber", {
                        required: "Student ID number is required",
                      })}
                      type="text"
                      placeholder="XX1234567890"
                    />
                    <ErrorMessage text={errors?.IDNumber?.message} />
                  </div>
                )}

                {providerMerchantDetails?.merchant_id === "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <InputWithLabel
                      labelText={"Mobile Phone"}
                      labelClasses="!capitalize !text-lg"
                      inputClasses="!border !border-gray-500"
                      {...register("phone", {
                        required: "Phone number is required",
                        minLength: {
                          value: 10,
                          message: "Phone number must be 10 chars",
                        },
                        maxLength: {
                          value: 10,
                          message: "Phone number must be 10 chars",
                        },
                      })}
                      type="number"
                      placeholder="0244454545"
                      min="1"
                    />
                    <ErrorMessage text={errors?.phone?.message} />
                  </div>
                )}
              </div>

              {/* Section 2 */}
              <div className="lg:flex justify-between w-full mb-3">
                {providerMerchantDetails?.merchant_id !== "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <InputWithLabel
                      labelText={"Mobile Phone"}
                      labelClasses="!capitalize !text-lg"
                      inputClasses="!border !border-gray-500"
                      {...register("phone", {
                        required: "Phone number is required",
                        minLength: {
                          value: 10,
                          message: "Phone number must be 10 chars",
                        },
                        maxLength: {
                          value: 10,
                          message: "Phone number must be 10 chars",
                        },
                      })}
                      type="number"
                      placeholder="0244454545"
                      min="1"
                    />
                    <ErrorMessage text={errors?.phone?.message} />
                  </div>
                )}
                {providerMerchantDetails?.merchant_id !== "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <InputWithLabel
                      labelText={"Email"}
                      labelClasses="!capitalize !text-lg"
                      inputClasses="!border !border-gray-500"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                      type="email"
                      placeholder="johndoe@mail.com"
                    />
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                )}
              </div>

              {/* Section 4 */}
              <div className="lg:flex justify-between w-full mb-3">
                {providerMerchantDetails?.merchant_id === "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <InputWithLabel
                      labelText={"Email"}
                      labelClasses="!capitalize !text-lg"
                      inputClasses="!border !border-gray-500"
                      {...register("email", {
                        required:
                          providerMerchantDetails?.merchant_id === "MER11618"
                            ? false
                            : "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                      type="email"
                      placeholder="johndoe@mail.com"
                    />
                    <ErrorMessage text={errors?.email?.message} />
                  </div>
                )}
                {providerMerchantDetails?.merchant_id !== "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <Label
                      text="Region of Residence"
                      labelClasses="!capitalize !text-lg"
                    />
                    <Select
                      selectClasses="px-2"
                      {...register("region", {
                        required: "Region of residence is required",
                      })}
                      data={regions}
                    />

                    <ErrorMessage text={errors?.region?.message} />
                  </div>
                )}

                {providerMerchantDetails?.merchant_id !== "MER11618" && (
                  <div className="lg:w-[48%] mb-3 lg:mb-0">
                    <InputWithLabel
                      labelText={"Hall of Residence (if applicable)"}
                      labelClasses="!capitalize !text-lg"
                      inputClasses="!border !border-gray-500"
                      {...register("hall", {})}
                      type="text"
                      placeholder="Casely-Hayford"
                    />
                  </div>
                )}
              </div>

              <div className="lg:flex justify-between w-full mb-3">
                <div className="lg:w-[48%] mb-3 lg:mb-0">
                  <label
                    className={`block text-black font-bold mb-1 !capitalize !text-lg`}
                  >
                    {"Date of Booking"}
                  </label>
                  <DatePicker control={control} name={"bookingDate"} />

                  <ErrorMessage text={errors?.bookingDate?.message} />
                </div>
                {/* <div className="lg:w-[48%] mb-3 lg:mb-0">
                  <label
                    className={`block text-black font-bold mb-1 !capitalize !text-lg`}
                  >
                    {"Date of Booking"}
                  </label>
                  <DatePicker control={control} name={"bookingDate"} />

                  <ErrorMessage text={errors?.bookingDate?.message} />
                </div> */}
                <div className="lg:w-[48%] mb-3 lg:mb-0">
                  <Label
                    text="Select your preferred booking time"
                    labelClasses="!capitalize !text-lg"
                  />
                  <Select
                    selectClasses="px-2"
                    {...register("bookingTime", {
                      required: `Select booking time`,
                    })}
                    data={timeSlots}
                  />
                  <ErrorMessage text={errors?.bookingTime?.message} />
                </div>
              </div>

              {/* Section 5 */}
              <div className="flex w-full justify-between">
                <button
                  disabled={loading}
                  className="flex items-center"
                  onClick={() => {
                    setComponentToRender("schedule");
                  }}
                >
                  <span className="text-2xl font-bold">&#8592; </span>
                  <span> Back</span>
                </button>
                <button
                  disabled={loading}
                  className={`px-6 py-2 ${
                    !loading ? "bg-brandGreen2" : "bg-gray-300"
                  }  text-white shadow rounded`}
                  onClick={handleSubmit(async (values) => {
                    setClientBookingDetails({
                      bookingDetails: values,
                    });

                    await onRaiseOrder(values);
                  })}
                >
                  <span>Continue</span>
                  <span> &#10140;</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Book;
